import http from '@/util/http'
// 询价结果
export function queryContentByOmiId (omiId) {
  return http({
    url: `/api/orderManualInquiry/queryContentByOmiId/${omiId}`,
    method: 'post'

  })
}

// 条件模糊搜索采购计划信息
export function queryByOrderContractStockupPurchase (processState, page, size, data) {
  return http({
    url: `/api/orderContractStockupPurchase/queryByOrderContractStockupPurchase/${processState}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 采购计划认领\处理\状态
export function updateProcessState (ocspCode, operate) {
  return http({
    url: `/api/orderContractStockupPurchase/updateProcessState/${ocspCode}/${operate}`,
    method: 'post'
  })
}

// 采购计划详情
export function queryOrderContractStockupPurchaseListsVo (ocspCode, isOcspMeger) {
  return http({
    url: `/api/orderContractStockupPurchase/queryOrderContractStockupPurchaseListsVo/${ocspCode}/${isOcspMeger}`,
    method: 'post'
  })
}
// 采购计划查询其他报价供应商
export function queryEnquiry (proId, page, size, suId, ocspId, data) {
  return http({
    url: `/api/orderContractStockupPurchase/queryEnquiry/${proId}/${page}/${size}/${suId}/${ocspId}`,
    method: 'post',
    data: data
  })
}
// 采购计划查询供应商
export function querySuName (page, size, data) {
  return http({
    url: `/api/orderContractStockupPurchase/querySuName/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 采购计划查询供应商
export function querySuNameBySuId (suId) {
  return http({
    url: `/api/orderContractStockupPurchase/querySuNameBySuId/${suId}`,
    method: 'post'

  })
}
// 生成合同
export function addPurchaseContractBase (spId, data) {
  return http({
    url: `/api/orderContractStockupPurchase/addPurchaseContractBase/${spId}`,
    method: 'post',
    data: data

  })
}
// 查看合同
export function queryByContract (ocspNumber) {
  return http({
    url: `/api/orderContractStockupPurchase/queryByContract/${ocspNumber}`,
    method: 'post'

  })
}
// 采购计划查看结果
export function queryAllContract (ocspNumber) {
  return http({
    url: `/api/orderContractStockupPurchase/queryAllContract/${ocspNumber}`,
    method: 'post'

  })
}

// 采购模块
export function queryAllPurchaseContractBase (contractState, page, size, data) {
  return http({
    url: `/api/purchaseContractBase/queryAllPurchaseContractBase/${contractState}/${page}/${size}`,
    method: 'post',
    data: data

  })
}
//
// 调入供应商信息
export function queryAllSupplierBase (page, size, data) {
  return http({
    url: `/api/purchaseContractBase/queryAllSupplierBase/${page}/${size}`,
    method: 'post',
    data: data

  })
}
// 根据供应商id获取采购合同信息
export function queryBySpId (spId) {
  return http({
    url: `/api/purchaseContractBase/queryBySpId/${spId}`,
    method: 'post'

  })
}
// 生成合同

export function purchaseContractBase (data) {
  return http({
    url: '/api/purchaseContractBase/add',
    method: 'post',
    data: data

  })
}

// 审核采购合同信息 - 详情
export function queryApprovalAll (pcbId) {
  return http({
    url: `/api/purchaseContractBase/queryApprovalAll/${pcbId}`,
    method: 'post'

  })
}

// 未签署的合同-采购信息
export function queryByPcbId (pcbId) {
  return http({
    url: `/api/purchaseContractBase/queryByPcbId/${pcbId}`,
    method: 'post'

  })
}
// 系统设置货期下拉框

export function queryDelivery () {
  return http({
    url: '/api/systemDeliverySetting/queryDelivery',
    method: 'post'
  })
}
// 采购合同修改采购参数
export function purchaseContractBaseUpdate (data) {
  return http({
    url: '/api/purchaseContractBase/update',
    method: 'post',
    data: data
  })
}
// 已签署合同-财务信息
export function queryPurchaseFinance (pcbId) {
  return http({
    url: `/api/purchaseContractBase/queryPurchaseFinance/${pcbId}`,
    method: 'post'

  })
}
// 根据采购合同id查询正常产品清单（分页

export function purchaseQueryByPcbId (pcbId, page, size, data) {
  return http({
    url: `/api/purchaseContractContent/queryByPcbId/${pcbId}/${page}/${size}`,
    method: 'post',
    time: 180000,
    data: data

  })
}
// 根据采购合同获取仓库报缺产品
export function queryPurchaseLack (pcbId, data) {
  return http({
    url: `/api/purchaseContractContent/queryPurchaseLack/${pcbId}`,
    method: 'post',
    data: data
  })
}
// 发货管理-入库

// 发货清单
export function queryShipmentPage (pcbId, data) {
  return http({
    url: `/api/purchaseContractDeliverBase/queryContractShipmentsVo/${pcbId}`,
    method: 'post',
    data: data

  })
}
// 产品清单-缺失/损毁上报
export function queryByLack (pcbId, page, size, data) {
  return http({
    url: `/api/purchaseContractContent/queryByLack/${pcbId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 采购合同-产品发起报缺
export function addPurchaseLack (data) {
  return http({
    url: '/api/purchaseContractContent/addPurchaseLack',
    method: 'post',
    data: data
  })
}

// 发货管理-入库

export function queryAllByPcbId (pcbId) {
  return http({
    url: `/api/purchaseContractDeliverBase/queryAllByPcbId/${pcbId}`,
    method: 'post'
  })
}

// 采购合同发货清单-导入产品序列号
export function queryLeadSerialCode (pcbId) {
  return http({
    url: '/api/purchaseContractDeliverBase/queryLeadSerialCode',
    method: 'post'
  })
}

// 入库源于采购(源于采购计划，生成合同)

export function addBySupplierContract (data) {
  return http({
    url: '/api/purchaseContractDeliverBase/addBySupplierContract',
    method: 'post',
    data: data
  })
}
// 发起发货-直发

export function queryShipmentMessageStraight (pcbId) {
  return http({
    url: `/api/purchaseContractDeliverBase/queryShipmentMessageStraight/${pcbId}`,
    method: 'post'

  })
}
// 根据发货编号查询发货详情
export function queryByDeliverNumber (deliverNumber) {
  return http({
    url: `/api/purchaseContractDeliverBase/queryByDeliverNumber/${deliverNumber}`,
    method: 'post'

  })
}
// 票据管理信息

export function queryAllInvocie (pcbId) {
  return http({
    url: `/api/purchaseContractInvocie/queryAllInvocie/${pcbId}`,
    method: 'post'

  })
}
// 收取普通发票申请信息

export function queryPageByProduct (pcbId, data) {
  return http({
    url: `/api/purchaseContractInvocie/queryPageByProduct/${pcbId}`,
    method: 'post',
    data: data

  })
}
// 申请开票

export function addInvocie (data) {
  return http({
    url: '/api/purchaseContractInvocie/addInvocie',
    method: 'post',
    data: data

  })
}
// 收票编号查询普通发票收票详情

export function queryPurchaseContractInvociesListVo (invoiceReceiveNumber) {
  return http({
    url: `/api/purchaseContractInvocie/queryPurchaseContractInvociesListVo/${invoiceReceiveNumber}`,
    method: 'post'

  })
}
// 退票/红字发票发货清单

export function queryInvoiceSub (pcbId, type) {
  return http({
    url: `/api/purchaseContractInvoiceSub/queryInvoiceSub/${pcbId}/${type}`,
    method: 'post'

  })
}
// 申请红字信息表-已收票产品
export function queryInvoiceContent (pciId) {
  return http({
    url: `/api/purchaseContractInvoiceSub/queryInvoiceContent/${pciId}`,
    method: 'post'

  })
}
// 红色提交

export function addInvoiceSub (data) {
  return http({
    url: '/api/purchaseContractInvoiceSub/addInvoiceSub',
    method: 'post',
    data: data

  })
}
// 票据管理 -申请退票

export function addPurchaseInvoiceSub (data) {
  return http({
    url: '/api/purchaseContractInvoiceSub/addPurchaseInvoiceSub',
    method: 'post',
    data: data

  })
}

// 红字信息表详情

export function queryInvoiceSubDetail (pcisId) {
  return http({
    url: `/api/purchaseContractInvoiceSub/queryInvoiceSubDetail/${pcisId}`,
    method: 'post'

  })
}
// 采购发货记录
//
export function queryPageAll (deliverState, page, size, data) {
  return http({
    url: `/api/purchaseContractDeliverBase/queryPageAll/${deliverState}/${page}/${size}`,
    method: 'post',
    data: data

  })
}
// 待支付供应商列表

export function querySupplierAccountBase (page, size, data) {
  return http({
    url: `/api/purchaseContractOtherPayment/querySupplierAccountBase/${page}/${size}`,
    method: 'post',
    data: data

  })
}

// 采购付款申请页面
// /api/purchaseContractOtherPayment/querySupplierAccount/{sabId}
export function querySupplierAccount (sabId) {
  return http({
    url: `/api/purchaseContractOtherPayment/querySupplierAccount/${sabId}`,
    method: 'post'

  })
}
// 付款记录

export function queryPayment (page, size, data) {
  return http({
    url: `/api/purchaseContractOtherPayment/queryPayment/${page}/${size}`,
    method: 'post',
    data: data

  })
}
// 根据供应商id添加交易账户
export function supplierBankAdd (data) {
  return http({
    url: '/api/supplierBank/add',
    method: 'post',
    data: data

  })
}
// 根据供应商id查看供应商账户
export function queryBySuId (suId) {
  return http({
    url: `/api/supplierBank/queryBySuId/${suId}`,
    method: 'get'

  })
}
// 申请付款

export function addPurchaseAccount (data) {
  return http({
    url: '/api/purchaseContractOtherPayment/addPurchaseAccount',
    method: 'post',
    data: data

  })
}
// 未收票合同列表
//
export function queryNoticket (page, size, data) {
  return http({
    url: `/api/purchaseContractInvocie/queryNoticket/${page}/${size}`,
    method: 'post',
    data: data

  })
}
// 未收票合同合并发票

export function addByMerge (data) {
  return http({
    url: '/api/purchaseContractInvocie/addByMerge',
    method: 'post',
    data: data
  })
}
// 团队采购计划记录
export function queryOrderStockupPurchaseTeam (page, size, data) {
  return http({
    url: `/api/orderContractStockupPurchase/queryOrderStockupPurchaseTeam/${page}/${size}`,
    method: 'post',
    data: data

  })
}
// 团队询价记录
export function queryPageTeam (page, size, data) {
  return http({
    url: `/api/orderManualInquiry/queryPageTeam/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 团队发货
export function queryByOrgId (page, size, data) {
  return http({
    url: `/api/orderContractDeliverGoods/queryByOrgId/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 团队备货
export function orderContractStockup (page, size, data) {
  return http({
    url: `/api/orderContractStockup/queryByOrgId/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 团队配货记录
export function queryTeamStock (page, size, data) {
  return http({
    url: `/api/orderContractStockup/queryTeamStock/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 团队采购合同
export function queryPurchaseTeam (page, size, data) {
  return http({
    url: `/api/purchaseContractBase/queryPurchaseTeam/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 团队发货记录
export function queryTeamDeliver (page, size, data) {
  return http({
    url: `/api/purchaseContractDeliverBase/queryTeamDeliver/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 团队收票记录

export function queryInvocieTeam (page, size, data) {
  return http({
    url: `/api/purchaseContractInvocie/queryInvocieTeam/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 付款申请详情
//
export function queryPayContent (scpId) {
  return http({
    url: `/api/purchaseContractOtherPayment/queryPayContent/${scpId}`,
    method: 'post'

  })
}
// 退回修改

export function updateModify (data) {
  return http({
    url: '/api/purchaseContractOtherPayment/updateModify',
    method: 'post',
    data: data

  })
}
// 合并采购计划
export function updateMerge (data) {
  return http({
    url: '/api/orderContractStockupPurchase/updateMerge',
    method: 'post',
    data: data
  })
}
// 重新发起-付款
export function querySupplierAccountByScpId (scpId, sabId) {
  return http({
    url: `/api/purchaseContractOtherPayment/querySupplierAccountByScpId/${scpId}/${sabId}`,
    method: 'post'

  })
}
// 更新报价
// /api/orderManualInquiry/updateBySoId
export function updateBySoId (data) {
  return http({
    url: '/api/orderManualInquiry/updateBySoId',
    method: 'post',
    data: data

  })
}
// 合并收票
export function queryMergePage (data) {
  return http({
    url: '/api/purchaseContractInvocie/queryMergePage',
    method: 'post',
    data: data
  })
}
// 合并收票列表
export function queryCompletedMergePage (page, size, data) {
  return http({
    url: `/api/purchaseContractInvocie/queryCompletedMergePage/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 合同作废/重新审核
export function updatePurchaseApprovalState (pcbId, state) {
  return http({
    url: `/api/purchaseContractBase/updatePurchaseApprovalState/${pcbId}/${state}`,
    method: 'post'
  })
}
// 修改货期提醒
export function updateByIsOpenExtime (pcbId, isOpenExtime) {
  return http({
    url: `/api/purchaseContractBase/updateByIsOpenExtime/${pcbId}/${isOpenExtime}`,
    method: 'post'
  })
}
// 采购合同-审核不通过(确认拒绝原因)
export function updateApprovalState (pcbId) {
  return http({
    url: `/api/purchaseContractBase/updateApprovalState/${pcbId}`,
    method: 'post'
  })
}

export function addPurchaseContractBaseSuId (suId, data) {
  return http({
    url: `/api/orderContractStockupPurchase/addPurchaseContractBase/${suId}`,
    method: 'post',
    data: data
  })
}
// /api/orderContractStockupPurchase/queryPurchaseContractBaseByOcsp/{state}/{page}/{size}
export function queryPurchaseContractBaseByOcsp (state, page, size, data) {
  return http({
    url: `/api/orderContractStockupPurchase/queryPurchaseContractBaseByOcsp/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 采购合同列表-售后管理

export function querySaleByPcbId (pcbId) {
  return http({
    url: `/api/purchaseContractRetreat/querySaleByPcbId/${pcbId}`,
    method: 'get'

  })
}
// 采购合同列表-售后管理

export function queryLaunchRetreat (pcbId) {
  return http({
    url: `/api/purchaseContractRetreat/queryLaunchRetreat/${pcbId}`,
    method: 'get'

  })
}
export function addRetreat (data) {
  return http({
    url: '/api/purchaseContractRetreat/addRetreat',
    method: 'post',
    data: data

  })
}
// 退货审批/详情

export function queryRetreatDetails (pcrId) {
  return http({
    url: `/api/purchaseContractRetreat/queryRetreatDetails/${pcrId}`,
    method: 'post'
  })
}
// 退货-合同 -详情

export function queryNotProducePage (pcrId) {
  return http({
    url: `/api/purchaseRetreatPact/queryNotProducePage/${pcrId}`,
    method: 'get'
  })
}
// 退货-合同 -生成

export function addRetreatContract (data) {
  return http({
    url: '/api/purchaseRetreatPact/addRetreatContract',
    method: 'post',
    data: data
  })
}
// 退货-合同 -作废

export function updateContract (prpId) {
  return http({
    url: `/api/purchaseRetreatPact/updateContract/${prpId}`,
    method: 'post'
  })
}

export function queryUploadPrP (prpId) {
  return http({
    url: `/api/purchaseRetreatPact/queryUploadPrP/${prpId}`,
    method: 'get'
  })
}
export function queryRetreatInvoice (prpId) {
  return http({
    url: `/api/purchaseContractRetreat/queryRetreatInvoice/${prpId}`,
    method: 'post'
  })
}
// 税率
export function queryFinanceBillTaxSettingAll () {
  return http({
    url: '/api/financeBillTaxSetting/queryFinanceBillTaxSettingAll',
    method: 'get'
  })
}

// 退货任务-票据管理申请退票
export function addRetreatInvoice (data) {
  return http({
    url: '/api/purchaseContractRetreat/addRetreatInvoice',
    method: 'post',
    data: data
  })
}
// 退货任务列表-物流管理列表首页
export function queryRetreatLogistic (pcrId) {
  return http({
    url: `/api/purchaseContractRetreat/queryRetreatLogistic/${pcrId}`,
    method: 'post'
  })
}
// 物流管理-新增出库单出库产品清单
export function queryRetreatProduct (pcrId, sbId) {
  return http({
    url: `/api/purchaseContractRetreat/queryRetreatProduct/${pcrId}/${sbId}`,
    method: 'post'
  })
}
// 查询所有仓库信息启用中(不分页)
export function queryAllByFlag () {
  return http({
    url: '/api/storageBase/queryAllByFlag',
    method: 'get'
  })
}
// 退货任务-物流管理列表收货人
export function querySupplierReceiveGoods (suId) {
  return http({
    url: `/api/purchaseContractRetreat/querySupplierReceiveGoods/${suId}`,
    method: 'post'
  })
}
// 退货物流管理-编辑收货人信息
export function updateSupplierRecevieGoods (data) {
  return http({
    url: '/api/purchaseContractRetreat/updateSupplierRecevieGoods',
    method: 'post',
    data: data
  })
}
// 退货物流管理-编辑收货人信息
export function addSupplierRecevieGoods (data) {
  return http({
    url: '/api/purchaseContractRetreat/addSupplierRecevieGoods',
    method: 'post',
    data: data
  })
}
// 退货物流管理-新建出库单
export function addRetreatLogistic (data) {
  return http({
    url: '/api/purchaseContractRetreat/addRetreatLogistic',
    method: 'post',
    data: data
  })
}
// 退货物流管理-新建出库单
export function queryRetreatLogisticStorage (pcrId) {
  return http({
    url: `/api/purchaseContractRetreat/queryRetreatLogisticStorage/${pcrId}`,
    method: 'post'
  })
}
// 退货物流管理-新建出库单
export function queryRetreatLogisticDetails (pcrlId) {
  return http({
    url: `/api/purchaseContractRetreat/queryRetreatLogisticDetails/${pcrlId}`,
    method: 'get'
  })
}
// 退货物流管理-新建出库单
export function queryPurchaseRetreatList (state, page, size, data) {
  return http({
    url: `/api/purchaseContractRetreat/queryPurchaseRetreatList/${page}/${size}/${state}`,
    method: 'post',
    data: data
  })
}
// 退款结算-确认结算方案页面
export function queryRepaymentScheme (pcrId) {
  return http({
    url: `/api/purchaseContractRetreat/queryRepaymentScheme/${pcrId}`,
    method: 'get'
  })
}
// 退款结算-确认结算方案提交
export function addRepaymentScheme (pcrId, payScheme) {
  return http({
    url: `/api/purchaseContractRetreat/addRepaymentScheme/${pcrId}/${payScheme}`,
    method: 'post'
  })
}
// 退款结算-申请收款
export function addRetreatReceipt (data) {
  return http({
    url: '/api/purchaseContractRetreat/addRetreatReceipt',
    method: 'post',
    data: data
  })
}

// 退款结算-申请付款详情
export function queryPaymentDetails (pcrrId) {
  return http({
    url: `/api/purchaseContractRetreat/queryPaymentDetails/${pcrrId}`,
    method: 'post'
  })
}
// shoukuanxiangqibng
export function queryReceiptDetails (pcrrId) {
  return http({
    url: `/api/purchaseContractRetreat/queryReceiptDetails/${pcrrId}`,
    method: 'post'
  })
}
/**
 * @author: wf
 * @createdate: 2021-02-25
 * @mark: 待处理退货产品列表
 */
export function queryPendGood (data = {}, query = { page: 1, size: 30, state: 0 }) {
  return http({
    url: `/api/purchaseContractRetreatContent/queryPendGood/${query.page}/${query.size}/${query.state}`,
    method: 'post',
    data
  })
}
// 待处理退货产品信息方案
export function queryGoodDetailsf (ocslcId) {
  return http({
    url: `/api/purchaseContractRetreatContent/queryGoodDetails/${ocslcId}`,
    method: 'post'
  })
}
// 已处理退货产品信息方案
export function queryGoodDetailsProcess (ocslcId) {
  return http({
    url: `/api/purchaseContractRetreatContent/queryGoodDetailsProcess/${ocslcId}`,
    method: 'post'
  })
}
// 待处理退货产品信息方案提交
export function addScheme (data) {
  return http({
    url: '/api/purchaseContractRetreatContent/addScheme',
    method: 'post',
    data
  })
}
/**
 * @author: wf
 * @createdate: 2021-03-01
 * @mark: 退货任务列表
 */
export function queryOrderSale (page, size, ids, data) {
  return http({
    url: `/api/purchaseContractRetreatContent/queryOrderSale/${page}/${size}/${ids}`,
    method: 'post',
    data
  })
}
// 待制定退货任务-确认制定
export function addRetreatByScheme (data) {
  return http({
    url: '/api/purchaseContractRetreatContent/addRetreatByScheme',
    method: 'post',
    data
  })
}
/**
 * @author: wf
 * @createdate: 2021-03-05
 * @mark: 合同详情退货产品
 */
export function queryPurchaseRetreatContent (page, size, pcbId, data) {
  return http({
    url: `/api/purchaseContractRetreatContent/queryPurchaseRetreatContent/${page}/${size}/${pcbId}`,
    method: 'post',
    data
  })
}
// 退货任务列表
export function queryTaskList (page, size, pcbId, data) {
  return http({
    url: `/api/purchaseContractContent/queryTaskList/${pcbId}/${page}/${size}`,
    method: 'post',
    data
  })
}
/**
 * @author: wf
 * @createdate: 2021-03-25
 * @mark: 团队退货任务记录
 */
export function queryTeamRetreat (page, size, data) {
  return http({
    url: `/api/purchaseContractRetreat/queryTeamRetreat/${page}/${size}`,
    method: 'post',
    data
  })
}
/**
 * @author: wf
 * @createdate: 2021-03-25
 * @mark: 提交修改付款账户
 */
export function updatePayment (receiptNumber, data) {
  return http({
    url: `/api/purchaseContractRetreat/updatePayment/${receiptNumber}`,
    method: 'post',
    data
  })
}
